const $win = $(window);
const $doc = $(document);

$(() => {
  if (window.matchMedia("(max-width: 991.98px)").matches) {
    $('ul.category-parent').each(function() {
      var list = $(this),
      select = $(document.createElement('select')).insertBefore($(this).hide()).on('change', function(){
        window.location.href=$(this).val();
      });
      $('>li a', this).each(function(){
        var option = $(document.createElement('option'))
        .appendTo(select)
        .val(this.href)
        .html($(this).html());
        if($(this).parent().hasClass('active')){
          option.attr('selected','selected');
        }
      });
      list.remove();
    });
  }
  
  // ajax pagination
  $(document).on('click', '.page-numbers', function() {
    $('.page-numbers').removeClass('current');
    var tis = $(this);
    var $href = $(this).attr('href');
    if((typeof $(this).attr('href') !== "undefined") && ($(this).attr('href') !== "javascript:void(0);")) {
      $(this).addClass('current');
      $.ajax({
        url: $href,
        context: document.body,
        beforeSend : function ( xhr ) {
          $('.page-load-status').show();
        },
        success : function( data ){
          if( data ) {
            if(tis.hasClass('page-numbers')){
              var output = $(data).find('.post-items-wrapper').html();
              $('.post-items-wrapper').html(output).fadeIn(200);
              $('.page-load-status').hide();
            }else {
              var output = $(data).find('.post-content').html();
              $('.post-content').html(output).fadeIn(200);
              $('.page-load-status').hide();
            }
          }else {
            $('.page-load-status').hide();
          }
        }
      })
      return false;
    }
  });

  // ajax product modal
  $(document).on('click', '.product-modal-link', function() {
    var data = {
      'action': 'post',
      product_page_id: $(this).data('product-id'),
      // product_page_id: ajax_products_data.post_id,
    };
    $.ajax({
      url : ajax_products_data.ajaxurl,
      data: data,
      type:'POST',
      beforeSend: function( xhr ){
        // you can also add your own preloader here
        // you see, the AJAX call is in process, we shouldn't run it again until complete
        $('.page-load-status').show();
      },
      success:function(data){
        // console.log(data);
        if( data ) {
          $('#ProductsModal').find('.modal-body').html( data ); // where to insert posts
          $('#ProductsModal').modal('show');
          $('.page-load-status').hide();
        }else {
          $('.page-load-status').hide();
        }
      }
    });
  });

  $(document).on('click', '.flipbook-button', function() {
    $('.flipbook-initialize').removeAttr('data-rendered');
    $('.flipbook-initialize').attr('data-pdf', $(this).data('pdf-url'));

    // re-render the data-rendered
    FB3D_CLIENT_LOCALE.render();

    // trigger flipbook after FB3D_CLIENT_LOCALE.render() was completed
    setTimeout(function(){
      $('.flipbook-initialize')[0].click();
    }, 0);
  });

  // after flipbook-initialize was triggered clicked
  $('.flipbook-initialize').on('click', function() {
    // remove download icon and print icon
    setTimeout(function(){
      var head = $(".fb3d-modal iframe").contents().find("head");
      var css = '<style type="text/css">' +
                '.cmdSave,.cmdPrint{display:none}; ' +
                '</style>';
      head.append(css);
    }, 400);
  });
});

$win.on('load', () => {
  // initial ajax product modal if product_id parameter in /our-product url is exist
  var data = {
    'action': 'post',
    product_page_id: ajax_products_data.post_id,
  };
  $.ajax({
    url : ajax_products_data.ajaxurl,
    data: data,
    type:'POST',
    beforeSend: function( xhr ){
      // you can also add your own preloader here
      // you see, the AJAX call is in process, we shouldn't run it again until complete
      // $('.page-load-status').show();
    },
    success:function(data){
      // console.log(data);
      if( data ) {
        $('#ProductsModal').find('.modal-body').html( data ); // where to insert posts
        $('#ProductsModal').modal('show');
        // $('.page-load-status').hide();
      }else {
        // $('.page-load-status').hide();
      }
    }
  });
});
